import styled from 'styled-components';
import ExploreTextKeys, { ExploreTranslations } from '../sportsbook-explore-text-keys';
import { BetRecommendationsCarousel } from '~/components/sportsbook/lobby/sportsbook-async';
import useBetRecommendationsWithEventSubscription from '../../../hooks/bet-recommendations/use-bet-recommendations-with-event-subscription';
import SportsbookSelectionTrackingTags from '../../../sportsbook-selection-tracking-tags';
import breakpoint from '../../../../../../utils/style-utils';
import { useSelector } from 'react-redux';
import { isSmallerSelector } from '../../../../../layout/mediaquery';
import { RecommendedBetDto } from '../../../api/sbapi/sbapi-api-model';
import useSportsbookBetslip from '../../../hooks/use-sportsbook-betslip';
import { useCallback } from 'react';
import useOddsFormat from '../../../hooks/use-odds-format';
import SportsbookContentHeader from '../../../components/header/sportsbook-content-header';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
`;

const LabelIcon = styled.span`
	font-size: 20px;
`;

const StyledSportsbookContentHeader = styled(SportsbookContentHeader)`
	padding: 0 10px;

	${breakpoint.lg`
		padding: 0;
	`}
`;

const CAROUSEL_NAME = 'BET_RECOMMENDATIONS_EXPLORE_CAROUSEL';
const BET_RECOMMENDATIONS_KEY = 'EXPLORE_PAGE_CAROUSEL';

type SportsbookExploreRecommendedBetsProps = {
	translations: ExploreTranslations;
};

const SportsbookExploreRecommendedBets: React.FC<SportsbookExploreRecommendedBetsProps> = ({ translations }) => {
	const { recommendedBets, isLoading } = useBetRecommendationsWithEventSubscription(BET_RECOMMENDATIONS_KEY);
	const { betslipSelectionIds, toggleSelections } = useSportsbookBetslip();
	const isSmall = useSelector(isSmallerSelector);
	const { oddsFormat } = useOddsFormat();

	const handleBetClick = useCallback(
		(recommendedBet: RecommendedBetDto) => {
			const selections = recommendedBet.items.map(item => item.selection);
			toggleSelections(selections, SportsbookSelectionTrackingTags.EXPLORE_RECOMMENDATIONS);
		},
		[toggleSelections]
	);

	if (!isLoading && recommendedBets?.length === 0) {
		return null;
	}

	return (
		<Wrapper>
			<StyledSportsbookContentHeader
				title={translations[ExploreTextKeys.BET_RECOMMENDATIONS_EXPLORE_CAROUSEL_TITLE]}
				titleSupportive={translations[ExploreTextKeys.BET_RECOMMENDATIONS_EXPLORE_CAROUSEL_TITLE_BETS]}
				iconElement={<LabelIcon>&#128293;</LabelIcon>}
			/>
			<BetRecommendationsCarousel
				carouselName={CAROUSEL_NAME}
				recommendedBets={recommendedBets}
				isLoading={isLoading}
				paddingX={isSmall ? 12 : 0}
				showArrows={!isSmall}
				activeSelectionIds={betslipSelectionIds}
				oddsFormat={oddsFormat}
				onBetClick={handleBetClick}
			/>
		</Wrapper>
	);
};

export default SportsbookExploreRecommendedBets;
